export const timesheetStatuses = {
  Open: "Open",
  PrPending: "Payroll (PR) Pending",
  Rejected: "Rejected",
  PrApproved: "Payroll (PR) Approved",
};
